import { hasPlatformFeature } from '../../utils'

const showDirectionControl = ({ campaignType, designFormat }) => {
  if (campaignType === 'email' && designFormat === 'custom_html') return false
  if (campaignType === 'form' && designFormat === 'simple') return false
  return true
}

export const DirectionSetting = ({
  direction = 'ltr',
  onChange,
  campaignType,
  designFormat,
  className = '',
  compact = false,
}) => {
  if (!hasPlatformFeature('design_direction') || !showDirectionControl({ campaignType, designFormat })) {
    return null
  }

  const setDirection = (value) => {
    if (value !== direction) onChange?.(value)
  }

  const buttonClass = compact ? 'px-2 py-1 text-xs' : 'px-4 py-2 text-sm'

  return (
    <div className={className}>
      {!compact && (
        <p className="text-sm font-medium text-secondary mb-2">Design direction</p>
      )}
      <div className="inline-flex rounded-md border border-gray-300 overflow-hidden">
        <button
          type="button"
          className={`${buttonClass} ${direction === 'ltr' ? 'bg-primary text-white' : 'bg-white text-secondary'}`}
          onClick={() => setDirection('ltr')}
        >
          {compact ? 'LTR' : 'Left to right'}
        </button>
        <button
          type="button"
          className={`${buttonClass} border-l border-gray-300 ${direction === 'rtl' ? 'bg-primary text-white' : 'bg-white text-secondary'}`}
          onClick={() => setDirection('rtl')}
        >
          {compact ? 'RTL' : 'Right to left'}
        </button>
      </div>
    </div>
  )
}
